export default "__VITE_ASSET__C9TudDV2__"